import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { Actions, Select, Store, ofActionSuccessful } from "@ngxs/store";
import { MatDialog } from '@angular/material/dialog';
import {
    NotesModel,
    TourModel,
    VehicleEventsModel,
} from "@core/services/api.service";
import { ActivatedRoute } from "@angular/router";
import { Navigate } from "@ngxs/router-plugin";
import { Observable, Subject } from "rxjs";
import {
    GetNotesAction,
    GetRouteByTourIdAction,
    GetTourByIdAction,
    GetTourByIdSuccessAction,
} from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { Location } from "@angular/common";
import {
    GetVehicleEventsAction,
    GetVehicleLocFromEventAction,
} from "@ngxs-store/vehicles-store/vehicles.action";
import { VehiclesState } from "@ngxs-store/vehicles-store/vehicles.state";
import { ManagedToursState } from "@ngxs-store/managed-tour-store/managed-tour.state";
import { DataSourceConfig } from "@core/models";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { LatLngLiteral } from "@agm/core";
import { Subject as SignalRSubject } from "@microsoft/signalr";
import { EditContactPersonDialogComponent } from "@shared/components/edit-contact-person-dialog/edit-contact-person-dialog.component";
import { ConfirmationDialogComponent } from "@shared/components/confirmation-dialog/confirmation-dialog.component";

@Component({
    selector: "app-control-tower-view-details",
    templateUrl: "./control-tower-view-details.component.html",
    styleUrls: ["./control-tower-view-details.component.scss"],
})
export class ControlTowerViewDetailsComponent implements OnInit, OnDestroy {
    @Select(VehiclesState.getVehicleEventsByTourId) vehicleHistory$: Observable<
        VehicleEventsModel[]
    >;
    @Input() vehicleHistory: VehicleEventsModel[];

    @Select(VehiclesState.getVehicleLocFromEvent)
    vehicleLoc$: Observable<VehicleEventsModel>;
    @Input() vehicleLoc: VehicleEventsModel;
    @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    detail: TourModel;
    vehicleDet: VehicleEventsModel;
    notes: NotesModel[] = [];
    lat: number;
    lng: number;
    imageUrl: string;
    //collection and vehicleId
    collectionLat: number;
    collectionLng: number;
    vehicleId: number;
    routeData: string = "";
    polylinePoints: Array<{ lat: number; lng: number }> = [];
    redPolylinePoints: Array<{ lat: number; lng: number }> = [];
    private unsubscribe$ = new Subject();
    selectedFilterBy: string = "";
    tourId: number;
    mapCenter: LatLngLiteral = { lat: 48.858093, lng: 2.294694 };
    markers: Array<{ lat: number; lng: number }> = [];
    dataSource: MatTableDataSource<VehicleEventsModel>;

    private refreshDialogSubject = new SignalRSubject<void>();

    transportOrderNumber: string | null = null;

    dataSourceConfig: DataSourceConfig = {
        name: "audit-table",
        columns: [
            "positionDateTime",
            "address",
            "countryCode",
            "zipCode",
            "nearestCity",
            "isManual",
        ],
        desktopModeColumns: [],
        mobileModeColumns: [],
        pageIndex: 10,
        pageSize: 10,
        pageSizeOptions: [10, 50, 100],
        filter: "",
        filterColumns: ["address", "countryCode"],
        selectedFilterColumns: ["address"],
        sortBy: "",
        sortByOrder: "",
    };

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private actions$: Actions,
        private location: Location,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog
    ) {
        const s = this.route.params.subscribe((params) => {
            // Access the optional parameter from the route
            if (params["filter"]) {
                this.selectedFilterBy = params["filter"];
                this.tourId = +params["id"];
            }
            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }
        });
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detail && changes.detail.currentValue) {
            const tour: TourModel = changes.detail.currentValue as TourModel;
            this.detail = tour;
        }
    }

    page(pageEvent: PageEvent) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            pageIndex: pageEvent.pageIndex,
            pageSize: pageEvent.pageSize,
        });
    }

    sortChange(sortEvent: Sort) {
        this.updateDataSourceConfig.emit({
            ...this.dataSourceConfig,
            sortByOrder: sortEvent.direction,
            sortBy: sortEvent.active,
        });
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource<VehicleEventsModel>();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.vehicleHistory$.subscribe((vehicle) => {
            this.vehicleHistory = vehicle;
            this.dataSource.data = vehicle.filter(
                (x) => x.disabled == false || x.disabled == null
            );
        });

        this.route.params.subscribe((params) => {
            const tourId = +params["id"];
            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }

            const sub = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((detail) => {
                    this.detail = detail.payload;
                    this.transportOrderNumber = this.detail?.transportOrderNumber ?? this.transportOrderNumber;
                    console.log(this.detail);
                    if (this.detail && this.detail.id) {
                        const id = this.detail.id;
                        this.lat = this.detail.destinationLatitude;
                        this.lng = this.detail.destinationLongitude;
                        this.markers.push({
                            lat: this.detail.destinationLatitude,
                            lng: this.detail.destinationLongitude,
                        });
                        this.collectionLat = this.detail.collectionLatitude;
                        this.collectionLng = this.detail.collectionLongitude;
                        this.markers.push({
                            lat: this.detail.collectionLatitude,
                            lng: this.detail.collectionLongitude,
                        });

                        // Get vehicle by vehicleId from tour
                        this.store.dispatch(
                            new GetVehicleLocFromEventAction(this.detail.id)
                        );

                        this.store
                            .select(VehiclesState.getVehicleLocFromEvent)
                            .subscribe((vehicleLoc) => {
                                this.vehicleDet = vehicleLoc;
                            });

                        //Get notes
                        this.store.dispatch(new GetNotesAction(id));

                        // Get latest route
                        this.store.dispatch(new GetRouteByTourIdAction(id));
                        this.store
                            .select(ManagedToursState.getRouteByTourId)
                            .subscribe((vehicleDet) => {
                                this.routeData = vehicleDet?.routeData;
                            });

                        if (this.routeData) {
                            try {
                                const routeArray = JSON.parse(this.routeData);
                                this.markers.push(
                                    routeArray.map((point) => ({
                                        lat: point.lat,
                                        lng: point.lng,
                                    }))
                                );
                                // Extracting latitude and longitude from the parsed array
                                this.polylinePoints = routeArray.map(
                                    (point) => ({
                                        lat: point.lat,
                                        lng: point.lng,
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    "Error parsing routeData:",
                                    error
                                );
                            }
                        }

                        //Get vehicle events & plot
                        this.store.dispatch(new GetVehicleEventsAction(id));
                        this.store
                            .select(VehiclesState.getVehicleEventsByTourId)
                            .subscribe((events) => {
                                this.redPolylinePoints = events.map(
                                    (event) => ({
                                        lat: event.latitude,
                                        lng: event.longitude,
                                    })
                                );
                            });
                    }
                    this.redPolylinePoints.forEach((point) => {
                        this.markers.push(point);
                    });
                    console.log(this.markers);
                    if (this.markers.length) {
                        const sumLat = this.markers.reduce(
                            (sum, marker) => sum + marker.lat,
                            0
                        );
                        const sumLng = this.markers.reduce(
                            (sum, marker) => sum + marker.lng,
                            0
                        );

                        // Calculate the average latitude and longitude
                        this.mapCenter.lat = sumLat / this.markers.length;
                        this.mapCenter.lng = sumLng / this.markers.length;
                    } else {
                        this.mapCenter = { lat: 48.858093, lng: 2.294694 };
                    }
                    sub.unsubscribe();
                });

            this.store.dispatch(new GetTourByIdAction(tourId, this.transportOrderNumber));

            this.store
                .select((state) => state.Tour.notes)
                .subscribe((notes) => {
                    this.notes = notes;
                });
        });
    }

    getTruckIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/amco-main-bw.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/amco-red-truck.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/amco-green-truck.png";
    }

    getCollectionIcon(
        planned: string,
        eta?: Date,
        actual?: Date,
        type?: string
    ): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;
        const ActualDateTime = actual;
        const ETA = eta;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/collect-base.png";
        }

        if (type == "Delivery") {
            if (ActualDateTime > plannedDate) {
                // ETA or actual time is after the planned time
                return "./assets/images/collect-1.png";
            } else {
                return "./assets/images/collect-2.png";
            }
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/collect-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/collect-2.png";
    }

    getDeliveryIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/delivery-base.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/delivery-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/delivery-2.png";
    }

    getTimeDifference(targetDateTime: string, ETADateTime: Date): string {
        const targetDate = new Date(targetDateTime);

        if (!ETADateTime) {
            //no eta then Delta should be blank
            return "";
        } else {
            // If ETA exists, calculate time difference between ETA and planned end
            const ETADate = new Date(ETADateTime);
            const timeDifference = Math.abs(
                ETADate.getTime() - targetDate.getTime()
            );
            const minutesDifference = Math.floor(timeDifference / (1000 * 60));

            const hours = Math.floor(minutesDifference / 60);
            const minutes = minutesDifference % 60;

            if (hours === 0 && minutes === 0) {
                return "0 hrs";
            }

            let timeDifferenceString = "";

            if (hours > 0) {
                timeDifferenceString += hours + "hr ";
            }
            if (minutes > 0) {
                timeDifferenceString += minutes + "min";
            }

            return timeDifferenceString.trim();
        }
    }

    resetMap() {
        this.polylinePoints = [];
        this.redPolylinePoints = [];
        this.routeData = "";

        this.polylinePoints = [...this.polylinePoints];
        this.redPolylinePoints = [...this.redPolylinePoints];
    }

    onMapReady(map: any): void {
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);
    }

    goBack() {
        if (this.selectedFilterBy) {
            this.store.dispatch(
                new Navigate(["/tours/", { filter: this.selectedFilterBy }])
            );
        } else {
            this.location.back();
        }
        this.resetMap();

        this.cdr.detectChanges();
    }

    editCustContact(email: string){
        const dialogRef = this.dialog.open(EditContactPersonDialogComponent, {
            data: { editTourId: this.tourId, emails: email, transportOrderNumber: this.transportOrderNumber }, disableClose: true, width: '1000px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));

            const sub1 = this.actions$
            .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
            .subscribe((successAction: GetTourByIdSuccessAction) => {
                if(successAction){
                    this.detail = successAction.payload;
                    this.refreshDialogSubject.next();
                    this.cdr.detectChanges();
                }

                sub1.unsubscribe();
            });
        });
    }

    deleteCustContact(){
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                id: this.tourId,
                modalTitle: 'Delete Contact Person Email',
                buttonType: 'Delete',
                confirmationText: `Are you sure you want to delete this Customer Contacts For Tracking?`
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result){

                const sub1 = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((successAction: GetTourByIdSuccessAction) => {
                    debugger
                    if(successAction){
                        this.detail = successAction.payload;
                        this.refreshDialogSubject.next();

                        this.detail.customerContactEmail = '';
                        this.cdr.detectChanges();
                    }

                    sub1.unsubscribe();
                });
                this.store.dispatch(new GetTourByIdAction(this.tourId, this.transportOrderNumber));
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getIcon(type: string, updatedBy: string): string {
        if (updatedBy == "ImportService") {
            return type == "Collection"
                ? "./assets/images/White-C.png"
                : "./assets/images/White-D.png";
        } else {
            return type == "Collection"
                ? "./assets/images/Green-C.png"
                : "./assets/images/Green-D.png";
        }
    }
}
